import { Create, TabbedForm } from 'react-admin';
import { ManufacturerResource } from '../../Entities/Manufacturer';
import SummaryTab from './Forms/SummaryTab';
import KeywordsTab from './Forms/KeywordsTab';
import { ReactElement } from 'react';

export default function ManufacturerCreate(): ReactElement {
  return (
    <Create<ManufacturerResource> redirect="edit">
      <TabbedForm>
        <SummaryTab />
        <KeywordsTab />
      </TabbedForm>
    </Create>
  );
}
